import React, { useState } from 'react';
import { Check, X, Sparkles, TrendingUp, Calendar, Users, FileText, Shield } from 'lucide-react';
import { Link } from 'react-router-dom';

const Pricing = () => {
  const [billingPeriod, setBillingPeriod] = useState('monthly'); // monthly or yearly

  const packs = {
    facturation: [
      {
        name: "Starter",
        price: { monthly: 79, yearly: 790 },
        description: "Idéal pour débuter",
        features: [
          { text: "1 utilisateur", included: true },
          { text: "10 sites max", included: true },
          { text: "Facturation complète (Devis, Factures, Avoirs)", included: true },
          { text: "Documents IA (GPT-4)", included: true },
          { text: "DPAE & CNAPS (4 solutions)", included: true },
          { text: "Gestion Clients & Agents", included: true },
          { text: "Caméras & Alarmes (suivi basique)", included: true },
          { text: "Rapports de sécurité", included: true },
          { text: "Support email", included: true },
          { text: "Planning avancé", included: false },
          { text: "Calcul de paie", included: false }
        ],
        popular: false,
        color: "blue"
      },
      {
        name: "Professional",
        price: { monthly: 149, yearly: 1490 },
        description: "Pour les PME en croissance",
        features: [
          { text: "5 utilisateurs", included: true },
          { text: "50 sites max", included: true },
          { text: "Facturation complète (Devis, Factures, Avoirs)", included: true },
          { text: "Documents IA illimités (GPT-4)", included: true },
          { text: "DPAE & CNAPS (4 solutions)", included: true },
          { text: "Gestion Clients & Agents", included: true },
          { text: "Caméras & Alarmes (illimité)", included: true },
          { text: "Rapports avancés + export", included: true },
          { text: "Support prioritaire", included: true },
          { text: "Dashboard analytics", included: true },
          { text: "Planning avancé", included: false },
          { text: "Calcul de paie", included: false }
        ],
        popular: true,
        color: "indigo"
      },
      {
        name: "Enterprise",
        price: { monthly: 249, yearly: 2490 },
        description: "Solution complète sans limites",
        features: [
          { text: "Utilisateurs illimités", included: true },
          { text: "Sites illimités", included: true },
          { text: "Facturation complète (Devis, Factures, Avoirs)", included: true },
          { text: "Documents IA illimités (GPT-4)", included: true },
          { text: "DPAE & CNAPS (4 solutions)", included: true },
          { text: "Gestion Clients & Agents", included: true },
          { text: "Tout illimité", included: true },
          { text: "AI Insights avancés", included: true },
          { text: "Support 24/7 + téléphone", included: true },
          { text: "Formation personnalisée", included: true },
          { text: "Planning avancé", included: false },
          { text: "Calcul de paie", included: false }
        ],
        popular: false,
        color: "purple"
      }
    ],
    planning: [
      {
        name: "Planning Standard",
        price: { monthly: 59, yearly: 590 },
        description: "Gestion planning efficace",
        features: [
          { text: "Jusqu'à 20 agents", included: true },
          { text: "Planning visuel", included: true },
          { text: "Gestion des shifts", included: true },
          { text: "Détection conflits", included: true },
          { text: "Calcul paie automatique", included: true },
          { text: "Heures majorées (nuit, férié)", included: true },
          { text: "Prime de panier", included: true },
          { text: "Export Excel", included: true },
          { text: "Support email", included: true },
          { text: "Planning Pro V9", included: false },
          { text: "Mobile app", included: false }
        ],
        popular: false,
        color: "green"
      },
      {
        name: "Planning Pro",
        price: { monthly: 99, yearly: 990 },
        description: "Solution professionnelle complète",
        features: [
          { text: "Jusqu'à 50 agents", included: true },
          { text: "Planning Pro V9 (Agendrix-like)", included: true },
          { text: "Drag & drop avancé", included: true },
          { text: "Templates de shifts", included: true },
          { text: "Shifts ouverts", included: true },
          { text: "Gestion remplaçants", included: true },
          { text: "Calcul paie automatique", included: true },
          { text: "Convention 1351 complète", included: true },
          { text: "Gestion congés", included: true },
          { text: "Notifications push", included: true },
          { text: "Support prioritaire", included: true }
        ],
        popular: true,
        color: "emerald"
      },
      {
        name: "Planning Enterprise",
        price: { monthly: 149, yearly: 1490 },
        description: "Grandes équipes sans limites",
        features: [
          { text: "Agents illimités", included: true },
          { text: "Planning Pro V9 complet", included: true },
          { text: "Toutes fonctionnalités Pro", included: true },
          { text: "API Planning", included: true },
          { text: "Intégrations personnalisées", included: true },
          { text: "Multi-sites avancé", included: true },
          { text: "Analytics avancés", included: true },
          { text: "Mobile app White Label", included: true },
          { text: "Support 24/7", included: true },
          { text: "Formation équipes", included: true },
          { text: "Account manager dédié", included: true }
        ],
        popular: false,
        color: "teal"
      }
    ],
    complet: [
      {
        name: "Starter Complet",
        price: { monthly: 110, yearly: 1100 },
        originalPrice: { monthly: 138, yearly: 1380 },
        discount: "-20%",
        description: "Pack tout-en-un pour débuter",
        features: [
          { text: "Facturation & CRM Starter", included: true },
          { text: "Planning Standard", included: true },
          { text: "1 utilisateur", included: true },
          { text: "10 sites, 20 agents", included: true },
          { text: "Économie de 28€/mois", included: true }
        ],
        popular: false,
        color: "indigo"
      },
      {
        name: "Professional Complet",
        price: { monthly: 199, yearly: 1990 },
        originalPrice: { monthly: 248, yearly: 2480 },
        discount: "-20%",
        description: "Solution professionnelle complète",
        features: [
          { text: "Facturation & CRM Professional", included: true },
          { text: "Planning Pro V9", included: true },
          { text: "5 utilisateurs", included: true },
          { text: "50 sites, 50 agents", included: true },
          { text: "Économie de 49€/mois", included: true },
          { text: "Tout illimité dans chaque module", included: true }
        ],
        popular: true,
        color: "purple"
      },
      {
        name: "Enterprise Complet",
        price: { monthly: 319, yearly: 3190 },
        originalPrice: { monthly: 398, yearly: 3980 },
        discount: "-20%",
        description: "Solution ultime sans limites",
        features: [
          { text: "Facturation & CRM Enterprise", included: true },
          { text: "Planning Enterprise", included: true },
          { text: "Tout illimité", included: true },
          { text: "Support 24/7 premium", included: true },
          { text: "Économie de 79€/mois", included: true },
          { text: "Formation + Account manager", included: true }
        ],
        popular: false,
        color: "pink"
      }
    ]
  };

  const [selectedCategory, setSelectedCategory] = useState('complet');

  const colorClasses = {
    blue: 'from-blue-500 to-blue-600',
    indigo: 'from-indigo-500 to-indigo-600',
    purple: 'from-purple-500 to-purple-600',
    green: 'from-green-500 to-green-600',
    emerald: 'from-emerald-500 to-emerald-600',
    teal: 'from-teal-500 to-teal-600',
    pink: 'from-pink-500 to-pink-600'
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-purple-50 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">
            Tarifs Transparents et Flexibles
          </h1>
          <p className="text-xl text-gray-600 mb-8">
            Choisissez l'offre qui correspond à vos besoins. Sans engagement. Résiliable à tout moment.
          </p>

          {/* Billing Toggle */}
          <div className="flex items-center justify-center gap-4 mb-8">
            <span className={`text-lg font-medium ${billingPeriod === 'monthly' ? 'text-indigo-600' : 'text-gray-500'}`}>
              Mensuel
            </span>
            <button
              onClick={() => setBillingPeriod(billingPeriod === 'monthly' ? 'yearly' : 'monthly')}
              className="relative inline-flex h-8 w-14 items-center rounded-full bg-indigo-600"
            >
              <span
                className={`inline-block h-6 w-6 transform rounded-full bg-white transition ${
                  billingPeriod === 'yearly' ? 'translate-x-7' : 'translate-x-1'
                }`}
              />
            </button>
            <span className={`text-lg font-medium ${billingPeriod === 'yearly' ? 'text-indigo-600' : 'text-gray-500'}`}>
              Annuel
            </span>
            {billingPeriod === 'yearly' && (
              <span className="bg-green-100 text-green-800 text-sm font-semibold px-3 py-1 rounded-full">
                -17% d'économie
              </span>
            )}
          </div>

          {/* Category Selection */}
          <div className="flex justify-center gap-4 mb-12">
            <button
              onClick={() => setSelectedCategory('complet')}
              className={`px-6 py-3 rounded-lg font-semibold transition-all ${
                selectedCategory === 'complet'
                  ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-lg scale-105'
                  : 'bg-white text-gray-700 hover:bg-gray-50'
              }`}
            >
              🎯 Pack Complet (-20%)
            </button>
            <button
              onClick={() => setSelectedCategory('facturation')}
              className={`px-6 py-3 rounded-lg font-semibold transition-all ${
                selectedCategory === 'facturation'
                  ? 'bg-gradient-to-r from-blue-500 to-indigo-500 text-white shadow-lg scale-105'
                  : 'bg-white text-gray-700 hover:bg-gray-50'
              }`}
            >
              💼 Facturation & CRM
            </button>
            <button
              onClick={() => setSelectedCategory('planning')}
              className={`px-6 py-3 rounded-lg font-semibold transition-all ${
                selectedCategory === 'planning'
                  ? 'bg-gradient-to-r from-green-500 to-emerald-500 text-white shadow-lg scale-105'
                  : 'bg-white text-gray-700 hover:bg-gray-50'
              }`}
            >
              📅 Planning & Paie
            </button>
          </div>
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {packs[selectedCategory].map((pack, index) => (
            <div
              key={index}
              className={`relative bg-white rounded-2xl shadow-xl overflow-hidden ${
                pack.popular ? 'ring-4 ring-indigo-500 scale-105' : ''
              }`}
            >
              {pack.popular && (
                <div className="absolute top-0 right-0 bg-gradient-to-r from-indigo-500 to-purple-500 text-white px-4 py-1 text-sm font-bold rounded-bl-lg">
                  ⭐ POPULAIRE
                </div>
              )}

              <div className={`bg-gradient-to-r ${colorClasses[pack.color]} p-6 text-white`}>
                <h3 className="text-2xl font-bold mb-2">{pack.name}</h3>
                <p className="text-sm opacity-90 mb-4">{pack.description}</p>
                
                <div className="flex items-baseline gap-2">
                  {pack.originalPrice && (
                    <span className="text-2xl line-through opacity-75">
                      {pack.originalPrice[billingPeriod]}€
                    </span>
                  )}
                  <span className="text-5xl font-bold">
                    {pack.price[billingPeriod]}€
                  </span>
                  <span className="text-lg">/{billingPeriod === 'monthly' ? 'mois' : 'an'}</span>
                </div>
                
                {pack.discount && (
                  <div className="mt-2 inline-block bg-white text-green-600 px-3 py-1 rounded-full text-sm font-bold">
                    {pack.discount} de réduction
                  </div>
                )}
              </div>

              <div className="p-6">
                <ul className="space-y-3 mb-6">
                  {pack.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      {feature.included ? (
                        <Check className="h-5 w-5 text-green-500 flex-shrink-0 mt-0.5" />
                      ) : (
                        <X className="h-5 w-5 text-gray-300 flex-shrink-0 mt-0.5" />
                      )}
                      <span className={feature.included ? 'text-gray-700' : 'text-gray-400'}>
                        {feature.text}
                      </span>
                    </li>
                  ))}
                </ul>

                <Link
                  to="/register-company"
                  className={`block w-full text-center py-3 px-6 rounded-lg font-semibold transition-all ${
                    pack.popular
                      ? 'bg-gradient-to-r from-indigo-500 to-purple-500 text-white hover:shadow-lg'
                      : 'bg-gray-100 text-gray-900 hover:bg-gray-200'
                  }`}
                >
                  Commencer l'essai gratuit
                </Link>
                <p className="text-center text-xs text-gray-500 mt-2">
                  14 jours gratuits • Sans carte bancaire
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Features Comparison */}
        <div className="bg-white rounded-2xl shadow-xl p-8 mb-12">
          <h2 className="text-3xl font-bold text-center mb-8">Ce qui est inclus</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {selectedCategory !== 'planning' && (
              <div>
                <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
                  <FileText className="h-6 w-6 text-blue-600" />
                  Facturation & CRM
                </h3>
                <ul className="space-y-2 text-gray-700">
                  <li>✅ Devis professionnels</li>
                  <li>✅ Factures conformes</li>
                  <li>✅ Avoirs (notes de crédit)</li>
                  <li>✅ Suivi paiements & relances</li>
                  <li>✅ Documents IA (GPT-4)</li>
                  <li>✅ DPAE & CNAPS (4 solutions)</li>
                  <li>✅ Gestion clients & sites</li>
                  <li>✅ Dashboard financier</li>
                </ul>
              </div>
            )}

            {selectedCategory !== 'facturation' && (
              <div>
                <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
                  <Calendar className="h-6 w-6 text-green-600" />
                  Planning & Paie
                </h3>
                <ul className="space-y-2 text-gray-700">
                  <li>✅ Planning visuel drag & drop</li>
                  <li>✅ Gestion des shifts</li>
                  <li>✅ Détection conflits auto</li>
                  <li>✅ Calcul paie automatique</li>
                  <li>✅ Convention 1351</li>
                  <li>✅ Heures majorées</li>
                  <li>✅ Prime de panier</li>
                  <li>✅ Gestion congés</li>
                </ul>
              </div>
            )}
          </div>
        </div>

        {/* CTA Final */}
        <div className="bg-gradient-to-r from-indigo-600 to-purple-600 rounded-2xl shadow-2xl p-12 text-center text-white">
          <h2 className="text-4xl font-bold mb-4">Prêt à transformer votre gestion ?</h2>
          <p className="text-xl mb-8 opacity-90">
            Rejoignez les entreprises de sécurité privée qui font confiance à HIGH TECH SECURITY
          </p>
          <Link
            to="/register-company"
            className="inline-block bg-white text-indigo-600 px-8 py-4 rounded-lg text-lg font-bold hover:bg-gray-100 transition-all shadow-lg"
          >
            Démarrer gratuitement pendant 14 jours
          </Link>
          <p className="mt-4 text-sm opacity-75">
            Aucune carte bancaire requise • Installation en 5 minutes • Support inclus
          </p>
        </div>
      </div>
    </div>
  );
};

export default Pricing;
